import { render } from "./ExpertModal.vue?vue&type=template&id=7dd1807a&scoped=true"
import script from "./ExpertModal.vue?vue&type=script&lang=js"
export * from "./ExpertModal.vue?vue&type=script&lang=js"

import "./ExpertModal.vue?vue&type=style&index=0&id=7dd1807a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dd1807a"]])

export default __exports__